import { render, staticRenderFns } from "./DokuView.vue?vue&type=template&id=63dabc8a"
import script from "./DokuView.vue?vue&type=script&lang=js"
export * from "./DokuView.vue?vue&type=script&lang=js"
import style0 from "./DokuView.vue?vue&type=style&index=0&id=63dabc8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports